import React from 'react';
import SectionHeader from '../components/ui/SectionHeader';
import Badge from '../components/ui/Badge';

export default function Overview() {
  return (
    <section>
      <SectionHeader id="overview" title="1. Executive Sales Overview" subtitle="The macro view of what we sell and why people buy it." />
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <div className="bg-slate-800 p-6 rounded-xl border border-slate-700">
          <h3 className="text-xl font-bold text-white mb-4">What We Sell</h3>
          <p className="text-slate-300 mb-4">
            We provide a <Badge type="recommended">Sports Media Ecosystem</Badge>. We help publishers, apps, and media companies instantly upgrade their football/sports coverage without hiring huge editorial or technical teams.
          </p>
          <ul className="space-y-2 text-slate-300">
            <li><strong className="text-white font-semibold">The Pitch Feed:</strong> Access to a football news feed with 40+ stories per day.</li>
            <li><strong className="text-white font-semibold">ScoreWidget:</strong> Engagement add-on (live data/interactive elements).</li>
            <li><strong className="text-white font-semibold">Fodbold TV:</strong> Utility add-on (streaming/TV schedules).</li>
          </ul>
        </div>

        <div className="bg-slate-800 p-6 rounded-xl border border-slate-700">
          <h3 className="text-xl font-bold text-white mb-4">The Commercial Story</h3>
          <p className="text-slate-300">
            "We solve the problem of needing a constant stream of football content without the cost and complexity of producing that full volume internally. We give you the volume to rank and the widgets to keep them on the page."
          </p>
        </div>
      </div>

      <div className="bg-slate-900 p-6 rounded-xl border border-slate-700 mb-8">
        <h3 className="text-lg font-bold text-white mb-4">Elevator Pitches</h3>
        <div className="space-y-4">
          <div>
            <span className="text-xs font-bold text-blue-400 uppercase tracking-wider">The 1-Sentence Value Prop</span>
            <p className="text-slate-300 italic">"We help sports platforms and publishers strengthen their football coverage with a scalable content solution that is faster and easier to run than building everything internally."</p>
          </div>
          <div>
            <span className="text-xs font-bold text-blue-400 uppercase tracking-wider">The 40+ Stories Angle</span>
            <p className="text-slate-300 italic">"We give you access to a football news feed with 40+ stories per day, making it easier to publish at scale without building the same output in-house."</p>
          </div>
        </div>
      </div>

      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1 bg-emerald-900/20 border border-emerald-500/30 p-4 rounded-lg">
          <h4 className="text-emerald-400 font-bold mb-2">Say This (Green):</h4>
          <ul className="text-sm text-slate-300 list-disc pl-4 space-y-1">
            <li>"Access to 40+ stories per day."</li>
            <li>"Scale your coverage instantly."</li>
            <li>"Editorial input + Original stories."</li>
            <li>"Plug-and-play integration."</li>
          </ul>
        </div>
        <div className="flex-1 bg-red-900/20 border border-red-500/30 p-4 rounded-lg">
          <h4 className="text-red-400 font-bold mb-2">Not That (Red):</h4>
          <ul className="text-sm text-slate-300 list-disc pl-4 space-y-1">
            <li>"We sell raw RSS feeds."</li>
            <li>"We are just an aggregator."</li>
            <li>"It's just automated content."</li>
            <li>"We offer a free trial." (CRITICAL: We do not)</li>
          </ul>
        </div>
      </div>
    </section>
  );
}